import { CustomRulesBaseDataProvider } from './CustomRulesBaseDataProvider';

export class CustomRulesNirvanaDataProvider extends CustomRulesBaseDataProvider {}
